import { Box, Typography } from '@mui/joy';

interface PageHeadingProps {
	bold?: string;
	regular?: string;
}

export const PageHeading = ({ bold, regular }: PageHeadingProps) => {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
			<Typography level='h3' sx={{ fontWeight: 'bold' }}>
				{bold}
			</Typography>
			<Typography level='h3' sx={{ fontWeight: 300, whiteSpace: 'nowrap' }}>
				{regular}
			</Typography>
		</Box>
	);
};
